"use client";

import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Button, type ButtonProps } from '@mui/material';
import React from 'react';
export const API_KEY_DOCS_URL = 'https://docs.descripio.com/authentication';
type ApiDocsLinkButtonProps = {
  label?: string;
} & Omit<ButtonProps, 'component' | 'href' | 'target' | 'rel' | 'children' | 'startIcon'>;
export default function ApiDocsLinkButton({
  label,
  ...buttonProps
}: ApiDocsLinkButtonProps) {
  return <Button component="a" href={API_KEY_DOCS_URL} target="_blank" rel="noopener noreferrer" startIcon={<DescriptionOutlinedIcon sx={{
    fontSize: 18
  }} />} {...buttonProps} data-sentry-element="Button" data-sentry-component="ApiDocsLinkButton" data-sentry-source-file="ApiDocsLinkButton.tsx">
      {label ?? 'Docs'}
    </Button>;
}